import {
  setEngineGeocode
} from '@/api/frotix'

const state = {}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async setEngineGeocode({ dispatch }, payload) {
    try {
      dispatch('overlay/show', true, { root: true })

      await setEngineGeocode(payload)

      dispatch(
        'notify/success',
        { message: 'Engine alterada com sucesso!' },
        { root: true }
      )
    } catch (error) {
      console.log('[ERROR-SET-ENGINE-GEOCODE] =>', error)

      dispatch(
        'notify/error',
        { message: 'Erro ao alterar engine!' },
        { root: true }
      )
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {},
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
